import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton } from '@mui/material';
import SearchSelectField from 'src/components/widgets/search-select-field';
import RefreshIcon from '@mui/icons-material/Refresh';

export const DropdownDynamic = ({
  label,
  name,
  items,
  hintValue,
  onSelected,
  onReset,
  disabled = false,
  showClearIcon = false
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(items);
  }, [items]);

  const handleChanged = (option) => {
    if (onSelected) {
      onSelected(option);
    }
  };

  const handleReset = () => {
    if(onReset){
      onReset();
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1 }}>
      {onReset && (
        <IconButton
          sx={{
            color: hintValue
              ? 'primary.main'
              : 'inherit',
          }}
          onClick={handleReset}
        >
          <RefreshIcon />
        </IconButton>
      )}
      <Box sx={{ flex: 1, ml: 1 }}>
        <SearchSelectField
          label={label}
          name={name}
          disabled={disabled}
          options={data}
          onSelected={handleChanged}
          hintValue={hintValue || ''}
          showClearIcon={showClearIcon}
        />
      </Box>
    </Box>
  );
};

DropdownDynamic.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  onSelected: PropTypes.func,
  onReset: PropTypes.func,
  disabled: PropTypes.bool,
  hintValue: PropTypes.string,
};

export default DropdownDynamic;
